import { ActiveAuthorization } from 'src/app/store/actions/authorizatios.actions';

export const SCHEDULED_SURGERY_ID = 202600;

// Autorizaciones accesibles solo por acceso directo con URL (ej. desde el chat bot).
// La API no las incluye en la respuesta del menú de "Cargar pedido", por lo que su
// label se resuelve acá. El code no se consume en el flujo, solo el id y el label.
export const OFF_MENU_AUTHORIZATIONS: Record<number, ActiveAuthorization> = {
  4: { id: 4, label: 'Adecuación de género auto percibido' },
};

// Provincias habilitadas para la carga de cirugías programadas (HU#17)
export const SCHEDULED_SURGERY_ALLOWED_PROVINCES = [
  'MENDOZA',
  'SAN JUAN',
  'TUCUMAN',
  'TUCUMÁN',
  'SAN LUIS',
  'LA PAMPA',
];

export const isScheduledSurgeryAllowed = (provinceName?: string): boolean =>
  SCHEDULED_SURGERY_ALLOWED_PROVINCES.includes(provinceName?.trim().toUpperCase() ?? '');
